module.exports = __webpack_public_path__ + "static/media/amalitech.516460d7.png";